<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <ResponseItem
        v-for="(option) in responses"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="true"
        :class="{
          'correct': option.correct,
          'incorrect': !option.correct,
        }"
      />
    </template>
    <template #answers>
      <ResponseItem
        v-for="(option) in answers"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="false"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>

<script>
import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    ResponseItem,
    TwoColumnQuizReviewLayout,
  },
  props: {
    report: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    answers() {
      return this.report?.answers?.map((a) => {
        return {
          title: a.title,
          image: a.image,
          pairTitle: a.pairtitle,
          pairImageCropped: a.pairimage,
        }
      })
    },
    responses() {
      return this.report?.response?.map((a) => {
        return {
          title: a.prompt_title,
          image: a.prompt_image,
          correct: a.correct,
          pairTitle: a.answer_title,
          pairImageCropped: a.answer_image,
        }
      })
    },
  },
}
</script>
